import { PropType } from "vue";
import { CarProps } from "./type";

export default {
  limit: Number,
  modelValue: [Array] as PropType<CarProps["modelValue"]>,
};
